(function () {
  'use strict';

  var TIMER_DURATION = 15 * 60 * 1000; // 15 minutes in ms

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initDispatchTimers() {
    var timers = document.querySelectorAll('.dispatch-timer');
    if (!timers.length) return;

    var startKey = 'dispatch_timer_start_' + window.location.pathname;
    var start = parseInt(sessionStorage.getItem(startKey), 10);
    if (!start || isNaN(start)) {
      start = Date.now();
      sessionStorage.setItem(startKey, start);
    }

    var interval;

    function tick() {
      var elapsed = Date.now() - start;
      var remaining = TIMER_DURATION - elapsed;

      timers.forEach(function (el) {
        var countdown = el.querySelector('.dispatch-timer__countdown');
        var heading = el.querySelector('.dispatch-timer__heading');
        var message = el.querySelector('.dispatch-timer__message');
        if (!countdown) return;

        if (remaining > 0) {
          var mins = Math.floor(remaining / 60000);
          var secs = Math.floor((remaining % 60000) / 1000);
          countdown.textContent = pad(mins) + ':' + pad(secs);
          el.classList.remove('dispatch-timer--expired');
        } else {
          var expired = el.dataset.expired || '';
          if (heading) heading.textContent = '';
          countdown.textContent = '';
          if (message) message.textContent = expired;
          el.classList.add('dispatch-timer--expired');
        }
      });

      if (remaining <= 0) {
        clearInterval(interval);
      }
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  // Copy button event delegation — handles .product-offers__copy buttons
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('product-offers__copy')) return;

    var btn = e.target;
    var code = btn.dataset.code || '';
    if (!code) return;

    function onCopied() {
      var prev = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = prev; }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(onCopied).catch(function () {
        fallbackCopy(code, onCopied);
      });
    } else {
      fallbackCopy(code, onCopied);
    }
  });

  function fallbackCopy(text, onCopied) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try {
      document.execCommand('copy');
      onCopied();
    } catch (e) {
      // silently fail
    }
    document.body.removeChild(ta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDispatchTimers);
  } else {
    initDispatchTimers();
  }
})();
